import PropTypes from "prop-types";
import { resolveMediaSources } from "./lib/resolve-media-sources";
import styles from "./styles/media.module.css";

export function Media({ src }) {
  return <div className={styles.mediaContainer}>{resolveMediaSources(src)}</div>;
}

Media.propTypes = {
  src: PropTypes.object.isRequired,
};
